import type { FC } from 'react';

import { Code, TextStrikethrough } from '@phosphor-icons/react';

import { ICON_CLASS } from '../constants';

export const BoldIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    fill="currentColor"
    className={ICON_CLASS}
    aria-hidden="true"
  >
    <path d="M170.48,115.7A44,44,0,0,0,140,40H72a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8h80a48,48,0,0,0,18.48-92.3ZM80,56h60a28,28,0,0,1,0,56H80Zm72,136H80V128h72a32,32,0,0,1,0,64Z" />
  </svg>
);

export const ItalicIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    fill="currentColor"
    className={ICON_CLASS}
    aria-hidden="true"
  >
    <path d="M200,56a8,8,0,0,1-8,8H157.77l-32.41,128H160a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.23l32.41-128H96a8,8,0,0,1,0-16h96A8,8,0,0,1,200,56Z" />
  </svg>
);

export const UnderlineIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    fill="currentColor"
    className={ICON_CLASS}
    aria-hidden="true"
  >
    <path d="M80,64V120a48,48,0,0,0,96,0V64a8,8,0,0,1,16,0v56a64,64,0,0,1-128,0V64a8,8,0,0,1,16,0ZM208,216H48a8,8,0,0,0,0,16H208a8,8,0,0,0,0-16Z" />
  </svg>
);

export const StrikeIcon: FC = () => <TextStrikethrough className={ICON_CLASS} aria-hidden="true" />;

export const CodeIcon: FC = () => <Code className={ICON_CLASS} aria-hidden="true" />;

export const TextTIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    fill="currentColor"
    className={ICON_CLASS}
    aria-hidden="true"
  >
    <path d="M208,56V88a8,8,0,0,1-16,0V64H136V192h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V64H64V88a8,8,0,0,1-16,0V56a8,8,0,0,1,8-8H200A8,8,0,0,1,208,56Z" />
  </svg>
);
